import {Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {Subscription} from 'rxjs';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { GoogleLoginProvider } from '@abacritt/angularx-social-login';
import {Cookie} from '../../helper/cookie';
import * as fromTrial from '../../profile/trial/store/trial.reducers';
import * as fromApp from '../../store/app.reducers';
import * as AuthActions from '../store/auth.actions';


@Component({
    selector: 'app-signup-google',
    templateUrl: './signup-google.component.html',
    styleUrls: ['./signup-google.component.scss'],
    standalone: false
})
export class SignupGoogleComponent implements OnInit, OnDestroy {

  cookies: Cookie;
  trialSubscription: Subscription;
  steps: any;
  clicked: boolean;

  constructor(
    private authService: SocialAuthService,
    public store: Store<fromApp.AppState>
  ) {
    this.cookies = new Cookie();
  }

  ngOnInit() {
    this.clicked = false;
    this.authService.authState.subscribe((user) => {
      const url = this.getNextUrl();
      // this.user = user;
      // this.loggedIn = (user != null);
      if (user !== null && user.provider === 'GOOGLE') {
        const token = user.idToken;
        if (this.clicked) {
          this.store.dispatch(
            new AuthActions.TrySingupByGoogle({
              accessToken: token,
              params: {
                uid: this.cookies.getCookie('auditor-uid'),
                redirectAfterSave: true,
                redirectUrl: url
              }
            })
          );
        }
      }

    });

    this.trialSubscription = this.store.select('trial').subscribe(
      (state: fromTrial.State) => {
        this.steps = state.steps;
      }
    );
  }

  getNextUrl() {
    const version = +this.cookies.getCookie('auditor-version');
    let url = ['/user/register/type'];
    if (version === 4) {
      url = ['/audits'];
    }
    if (version === 3) {
      url = this.steps.payment.url;
    }
    if (version === 5) {
      url = this.steps.payment.url;
    }

    return url;
  }

  signInWithGoogle(): void {
    this.clicked = true;
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  ngOnDestroy() {
    this.trialSubscription.unsubscribe();
  }

}
